/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ToolIdRequest} from '../models/ToolIdRequest';

export interface GetUserResources$Request {
    userId: number;
}

export interface GetUserResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserResourcesRequest = createAction<PayloadData<void, GetUserResources$Request>>('USER_ACCESS__GET_USER_RESOURCES__REQUEST');
export const getUserResourcesSuccess = createAction<PayloadData<Array<string>, GetUserResources$Request>>('USER_ACCESS__GET_USER_RESOURCES__SUCCESS');
export const getUserResourcesFailure = createAction<PayloadData<Error, GetUserResources$Request, true>>('USER_ACCESS__GET_USER_RESOURCES__FAILURE');

export const getUserResourcesActions = [
    getUserResourcesRequest,
    getUserResourcesSuccess,
    getUserResourcesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserResources = (meta: GetUserResources$Request, config?: GetUserResources$Config) => {
    return {
        CALL_API: {
            types: getUserResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/resources`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserToolResources$Request {
    userId: number;
    toolId: ToolIdRequest;
}

export interface GetUserToolResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserToolResourcesRequest = createAction<PayloadData<void, GetUserToolResources$Request>>('USER_ACCESS__GET_USER_TOOL_RESOURCES__REQUEST');
export const getUserToolResourcesSuccess = createAction<PayloadData<Array<string>, GetUserToolResources$Request>>('USER_ACCESS__GET_USER_TOOL_RESOURCES__SUCCESS');
export const getUserToolResourcesFailure = createAction<PayloadData<Error, GetUserToolResources$Request, true>>('USER_ACCESS__GET_USER_TOOL_RESOURCES__FAILURE');

export const getUserToolResourcesActions = [
    getUserToolResourcesRequest,
    getUserToolResourcesSuccess,
    getUserToolResourcesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {ToolIdRequest} meta.toolId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserToolResources = (meta: GetUserToolResources$Request, config?: GetUserToolResources$Config) => {
    return {
        CALL_API: {
            types: getUserToolResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/tools/${meta.toolId}/resources`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

